import React, { useEffect, useState } from "react";
import "./style.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import Sidebar from "../../../../components/sidebar";
import { useOutletContext, useParams } from "react-router-dom";
import { FiClock } from "react-icons/fi";
import { MdOutlineCalendarToday } from "react-icons/md";
import { LuMapPin } from "react-icons/lu";
import { useDispatch } from "react-redux";
import { getLogHourDetails } from "../../../../core/data/redux/logHour/_logHourAction";
import BuildingIcon from "../../../../icons/BuildingIcon";
import TagBlueIcon from "../../../../icons/TagBlueIcon";
import { formatDate, logHourFormatTime } from "../../../../constants/date";
import { capitalizeFullName } from "../../../../constants/common";

const SpouseLogHoursDetail = () => {
  const { isSidebarOpen } = useOutletContext<{ isSidebarOpen: boolean; onToggleSidebar: () => void }>();
  const { id } = useParams<{ id: string }>();
  const dispatch: any = useDispatch();

  const [logHour, setLogHour] = useState<any>({});

  useEffect(() => {
    getLogHourData();
  }, [dispatch]);

  // get log hour data
  const getLogHourData = async () => {
    try {
      const response = await dispatch(getLogHourDetails({ uuid: id }));
      const logData = response?.payload?.data || [];
      setLogHour(logData);
      return
    } catch (error) {
      console.error("Failed to fetch all property:", error);
    }
  }

  return (
    <div className="layout">
      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} />

      {/* Main Content */}
      <main className="content mb-5">
        <div className="help-center profileSettings p-4 log-hours-details-page">
          <div className="log-hours-details-inner">
            <div className="card p-4">
              <div className="d-flex flex-wrap gap-2 mb-3">
                <span
                  // className="badge bg-primary badge-custom"
                  className={logHour?.main_category?.name.toLowerCase() == "material participation" ? "badge bg-primary badge-custom" : "category-badge yellow"}
                >
                  {logHour?.main_category?.name}
                </span>

                <span
                  className="badge bg-success badge-custom"
                >
                  {logHour?.status?.toLowerCase() == "reject" ? "Rejected" : logHour?.status?.toLowerCase() == "accept" ? "Accepted" : ""}
                </span>
              </div>


              <h4 className="fw-bold">
                {logHour?.sub_activity?.name}
              </h4>

              <div className="row text-muted my-3 villa-manage-button">
                <div className="d-flex flex-wrap gap-2">
                  <span className="badge bg-primary badge-custom Sunset-Villa gap-2 align-items-center">
                    <BuildingIcon /> &nbsp;
                    {logHour?.property?.name}
                  </span>

                  <span className="badge bg-success badge-custom Management gap-2">
                    <TagBlueIcon /> &nbsp;
                    {logHour?.activity?.name}
                  </span>
                </div>
              </div>

              <div className="row text-muted my-3">
                <div className="col-12 col-md-12 time mb-2">
                  <FiClock className="clock-icon" /> &nbsp;
                  {logHourFormatTime({ hours: logHour?.hours, minutes: logHour?.minutes })}
                </div>

                <div className="col-12 col-md-12 date  mb-2">
                  <MdOutlineCalendarToday className="clock-icon" /> &nbsp;
                  {formatDate(logHour?.date)}
                </div>

                <div className="col-12 col-md-12 address  mb-2">
                  <LuMapPin className="clock-icon" /> &nbsp;
                  {logHour?.property?.address}, {logHour?.property?.city}, {logHour?.property?.state}{" "}  {logHour?.property?.zipcode}
                </div>
              </div>

              <h4 className="fw-bold">Description</h4>
              <p className="text-muted mb-4">
                {logHour?.description}
              </p>

              {logHour?.notes && (
                <>
                  <h4 className="fw-bold">Additional Notes</h4>
                  <p className="text-muted mb-4">
                    {logHour?.notes}
                  </p>
                </>
              )}

              {logHour?.receipt_images?.length > 0 && (
                <>
                  <h4 className="fw-bold">Receipt</h4>

                  <div className="receipt-images mb-4">
                    {logHour.receipt_images.map((receipt: { uuid: string; image: string; uploaded_at: string }) => {
                      // Check if the file is an image based on its extension
                      const isImage = /\.(png|jpg|jpeg|gif|bmp|webp)$/i.test(receipt?.image);

                      return isImage ? (
                        <img
                          key={receipt?.uuid}
                          src={receipt?.image}
                          alt={`Receipt uploaded at ${receipt?.uploaded_at}`}
                          className="receipt-img"
                        />
                      ) : (
                        <a
                          key={receipt?.uuid}
                          href={receipt?.image}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="document-link"
                          title={`Document uploaded at ${receipt?.uploaded_at}`}
                        >
                          <div className="document-preview">
                            <span className="document-icon">📄</span>
                            <span className="document-name">
                              {receipt?.image.split('/').pop() || 'Document'}
                            </span>
                          </div>
                        </a>
                      );
                    })}
                  </div>
                </>
              )}

              {logHour?.cpa_comment && (
                <>
                  <h4 className="fw-bold">Commented</h4>
                  <div className="comment-box mb-3">
                    <div className="comment-box image d-flex flex-wrap gap-3 align-items-center">
                      <img
                        src={logHour?.cpa_comment?.image || "/assets/img/userCircle.png"}
                      >
                      </img>

                      <div className="comment-box image-text text-center">
                        <span className="text-muted">Tax Professional</span>
                        <br></br>
                        <strong>{capitalizeFullName(logHour?.cpa_comment?.name)}</strong>
                      </div>
                    </div>

                    <p className="mt-2 text-muted">
                      {logHour?.cpa_comment?.comment}
                    </p>
                  </div>
                </>
              )}

              {logHour?.reason && (
                <>
                  <h4 className="fw-bold">Reason</h4>
                  <p className="text-muted">
                    {logHour?.reason}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default SpouseLogHoursDetail;
